import React from "react";

export default function MappedIcon({
  size = 18, // or any default size of your choice
  color = "black", // or any color of your choice
  margin = "0 0 0 0",
}) {
  const iconStyle = { fill: "none", stroke: color, strokeWidth: "1" };

  return (
    <span style={{ display: "inline-block", margin: margin }}>
      <svg
        width={size}
        height={size}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24.7 27"
      >
        <rect x="3.6" y="7.7" style={iconStyle} width="6.5" height="6.5" />
        <rect x="3.6" y="17.2" style={iconStyle} width="6.5" height="6.5" />
        <line style={iconStyle} x1="12.4" y1="9" x2="21" y2="9" />
        <line style={iconStyle} x1="12.4" y1="11.7" x2="18.9" y2="11.7" />
        <line style={iconStyle} x1="12.4" y1="19" x2="21" y2="19" />
        <line style={iconStyle} x1="12.4" y1="21.7" x2="18.9" y2="21.7" />
        <g>
          <path
            style={iconStyle}
            d="M17.6,2.8v0.8c0,0.3-0.2,0.5-0.5,0.5H7.9C7.6,4.2,7.3,4,7.3,3.7V2.8H0.5v23.7h23.7V2.8H17.6z"
          />
          <path
            style={iconStyle}
            d="M17.6,2.8V1.1c0-0.3-0.2-0.5-0.5-0.5H7.9c-0.3,0-0.5,0.2-0.5,0.5v1.8"
          />
        </g>
      </svg>
    </span>
  );
}
